<template>
  <el-dialog title="窜货信息" :visible.sync="dialogTableVisible" append-to-body>
    <div class="view pa24">
      <commonTable
          :tableData="tableData"
          :total="total"
          :currentPage="pageNum"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:table>
          <el-table-column
              prop="className"
              align="center"
              label="产品"
          />
          <el-table-column
              prop="handle"
              align="center"
              label="标识"
          >
            <template slot-scope="scope">
              {{ scope.row.handle }}
              <span
                  :class="scope.row.type == 3?'name_status':'name_status1'">{{ scope.row.type == 3 ? '箱' : '盒' }}</span>
              <span class="copyTxt" @click="copy(scope.row.handle)"><img src="../../../assets/images/fz.png"/></span>
            </template>
          </el-table-column>
          <el-table-column
              prop="scanAddress"
              align="center"
              label="疑似窜货地址"
          />
          <el-table-column
              prop="area"
              align="center"
              label="指定区域"
          />
          <el-table-column
              prop="createTime"
              align="center"
              label="时间"
          />
        </template>
      </commonTable>
    </div>
  </el-dialog>

</template>
<script>
import commonTable from "@/components/common/commonTable";
import {dlFleeingDetail} from '@/api/crk'

export default {
  name: "fleeingDetail",
  components: {
    commonTable
  },
  data() {
    return {
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      serchParams: {
        dlId: '',
        dealerId: '',
        timeRange: []
      },
      dlOptions: [],
      dealerOptions: [],
      fullscreenLoading: false,
      wareStatus: -1,
      dealerId: '',
      type:'',
      dialogTableVisible:false
    };
  },
  props: {},
  created() {

  },
  mounted() {
    // this.getList()
  },
  methods: {
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    search() {
      this.pageNum = 1
      this.getList()
    },
    resetSearch() {
      this.pageNum = 1
      this.getList()
    },
    init(dealerId, type) {
      this.type = type
      this.dealerId = dealerId
      this.tableData = []
      this.getList()
      this.dialogTableVisible= true
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        dealerId: this.dealerId,
        type:this.type
      }
      dlFleeingDetail(params).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    copy(context) {
      // 创建输入框元素
      let oInput = document.createElement('input');
      // 将想要复制的值
      oInput.value = context;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand('Copy');
      // 弹出复制成功信息
      this.$message.success('复制成功');
      // 复制后移除输入框
      oInput.remove();
    },
  }
}
</script>

<style lang="scss" scoped>
.greenTag {
  color: #fff;
  background: #08A89B;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.redTag {
  background: #e5e5e5;
  color: #f00;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;
}

.name_status {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(63, 114, 246, 0.11);
  border: 1px solid #3F72F6;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3F72F6;
  text-align: center;
}

.name_status1 {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(243, 136, 46, 0.11);
  border: 1px solid #F3882E;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #F3882E;
  text-align: center;
}

.copyTxt {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
  color: #3F72F6;
}
</style>

